import React from 'react';

import { OrganizationAppShell, Settings } from '~/components/layouts';
import { Practitioners } from '~/components/pages/Settings_Practitioners';
import { FirebaseProvider } from '~/components/partials';

const SettingsPractitionersPage = () => {
  return (
    <FirebaseProvider>
      <OrganizationAppShell>
        <Settings>
          <Practitioners />
        </Settings>
      </OrganizationAppShell>
    </FirebaseProvider>
  );
};

export default SettingsPractitionersPage;
